import {createRoot} from 'react-dom/client';
import '@fontsource/heebo/hebrew-400.css';
import '@fontsource/heebo/hebrew-500.css';
import '@fontsource/heebo/hebrew-700.css';
import '@fontsource/heebo/latin-400.css';
import '@fontsource/heebo/latin-500.css';
import '@fontsource/heebo/latin-700.css';
import './app/i18n';
import './styles.css';
import './themes.css';
import App from './app/App';
createRoot(document.getElementById('root')!).render(<App/>);
